import { css } from 'styled-components';

/**
 * Дизайн-токены SMART-KVADRAT.
 * Палитра: технологичный синий + белый + угольный/графит,
 * аккуратные градиенты на основе синего и сиреневого.
 */
const variables = css`
  :root {
    /* Основной бренд */
    --blue: #5670f6;
    --blue-bright: #6e86ff;
    --blue-soft: #aebcff;
    --violet: #7c5cff;
    --fuchsia: #fd76ff;
    --cyan: #38bdf8;

    /* Тёмные поверхности: charcoal / graphite */
    --ink-950: #070a14;
    --ink-900: #0a0f1e;
    --ink-800: #101830;
    --ink-700: #1a2440;
    --ink-600: #263252;

    /* Текст и линии на тёмном */
    --on-dark: #eaf0ff;
    --on-dark-soft: #a9b4d0;
    --on-dark-mute: #7c89a8;
    --on-dark-line: rgba(255, 255, 255, 0.1);
    --on-dark-line-strong: rgba(255, 255, 255, 0.2);

    /* Светлые поверхности */
    --paper: #ffffff;
    --paper-soft: #f5f8ff;
    --paper-tint: #eaf0ff;
    --line: #e2e8f5;

    /* Текст на светлом */
    --text: #0b1220;
    --text-soft: #47506a;
    --text-mute: #6b7690;

    /* Градиенты и тени */
    --gradient: linear-gradient(135deg, #5670f6 0%, #7c5cff 52%, #fd76ff 100%);
    --gradient-blue: linear-gradient(135deg, #5670f6 0%, #38bdf8 100%);
    --gradient-soft: linear-gradient(135deg, rgba(86, 112, 246, 0.14), rgba(253, 118, 255, 0.14));
    --glow-blue: 0 40px 90px -40px rgba(86, 112, 246, 0.65);
    --shadow-card: 0 24px 60px -34px rgba(11, 18, 32, 0.38);
    --shadow-soft: 0 14px 34px -26px rgba(11, 18, 32, 0.55);

    /* Скругления */
    --radius-sm: 10px;
    --radius: 16px;
    --radius-lg: 24px;
    --radius-xl: 32px;
    --border-radius: 12px;

    /* Типографика */
    --font-sans: 'Calibre', 'Inter', 'San Francisco', 'SF Pro Text', -apple-system, system-ui,
      sans-serif;
    --font-mono: 'SF Mono', 'Fira Code', 'Fira Mono', 'Roboto Mono', monospace;

    --fz-xxs: 12px;
    --fz-xs: 13px;
    --fz-sm: 15px;
    --fz-md: 17px;
    --fz-lg: 19px;
    --fz-xl: 21px;
    --fz-xxl: 24px;
    --fz-xxxl: 28px;
    --fz-heading: 34px;

    /* Раскладка */
    --container: 1160px;
    --nav-height: 78px;
    --nav-scroll-height: 66px;

    /* Анимации */
    --easing: cubic-bezier(0.22, 1, 0.36, 1);
    --transition: all 0.25s cubic-bezier(0.22, 1, 0.36, 1);

    --hamburger-width: 30px;
    --ham-before: top 0.1s ease-in 0.25s, opacity 0.1s ease-in;
    --ham-before-active: top 0.1s ease-out, opacity 0.1s ease-out 0.12s;
    --ham-after: bottom 0.1s ease-in 0.25s, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);
    --ham-after-active: bottom 0.1s ease-out,
      transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;

    /* Совместимость с прежними именами переменных */
    --navy: #0a0f1e;
    --dark-navy: #070a14;
    --light-navy: #101830;
    --lightest-navy: #1a2440;
    --navy-shadow: rgba(7, 10, 20, 0.6);
    --dark-slate: #263252;
    --slate: #8b96b5;
    --light-slate: #a9b4d0;
    --lightest-slate: #eaf0ff;
    --white: #ffffff;
    --green: #5670f6;
    --green-tint: rgba(86, 112, 246, 0.12);
    --pink: #fd76ff;

    --tab-height: 42px;
    --tab-width: 120px;
  }
`;

export default variables;
